import React, { useEffect, useState } from "react";
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { SuccessOk } from "configs/statusCode";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import Language from "Enums/Language"
import SalesDeveloperService from "services/SalesDeveloper/SalesDeveloperService";

const languages = ["en", "ar", "zh", "ru"]

function EditProfile({ modal, toggle, data }) {
    const [loading, setLoading] = useState(false)
    const service = new SalesDeveloperService()

    const [formData, setFormData] = useState({
        en: "",
        ar: "",
        ru: "",
        zh: "",
        phone:"",
        email: ""
    })

    useEffect(() => {
        setFormData({
            ...data.name,
            phone: data.phone,
            email: data.email
        })
    }, [])

    const handleFieldChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleValidSubmit = () => {
        setLoading(true)
        let reqData = {
            name: {
                en: formData.en,
            },
            phone: formData.phone,
            email: formData.email,
        }
        
        languages.forEach(language => {
            if (formData[language].length) {
                reqData.name[language] = formData[language]
            }
        })

        service.update(reqData).then(res=>{
            if (res && res.status === SuccessOk) {
                setLoading(false)
                toast.success("Profile Updated Successfully")
                toggle()
            } 
        })
    }

    return (
        <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
            <ModalHeader toggle={toggle}>
                Edit Profile
            </ModalHeader>
            <ModalBody>
                <AvForm
                    className='form-horizontal'
                    onValidSubmit={(e, v) => {
                        handleValidSubmit(e, v);
                    }}>
                    <Row>
                        {Language.LIST.map((lan, index) => {
                            return (
                                <Col md={6} key={index} className="mb-3">
                                    <AvField
                                        name={lan.name}
                                        label={lan.label}
                                        bsSize="lg"
                                        value={formData[`${lan.name}`]}
                                        onChange={(e => handleFieldChange(e))}
                                        validate={{
                                            required: {value: lan.name === "en" ? true : false, errorMessage: 'This Field is required'},
                                            pattern: {value: lan.name === "en" ? '/^[A-Za-z ]+$/' : lan.name === "ar" ? '/^[\u0621-\u064A ]+$/' : "", errorMessage: `${lan.name=='en' ? "English" : "Arabic"} format is invalid`}
                                        }}
                                        placeholder={lan.name === "en" ? 'Name' : lan.name === "ar" ? "الاسم" : lan.name === "zh" ? "姓名" : "Каир"}
                                    />
                                </Col>
                            )
                        })}
                        <Col md={6} className="mb-3">
                            <AvField
                                name="phone"
                                label={"Phone"}
                                placeholder={"123456789"}
                                className='form-control'
                                value={formData.phone}
                                validate={{
                                required: {value: true, errorMessage: 'This Field is required'},
                                pattern: {value: '^01[0-9]+$', errorMessage: "The Phone format is invalid"},
                                minLength: {value: 11, errorMessage: 'The Phone must be 11 characters'},
                                maxLength: {value: 11, errorMessage: 'The Phone must be 11 characters'},
                                }}
                                onChange={(e) => {
                                handleFieldChange(e)
                                }}
                                bsSize="lg"
                                type="number"
                            />
                        </Col>
                        <Col md={6}>
                            <div className='mb-3'>
                            <AvField
                                name='email'
                                label={"Email"}
                                value={formData.email}
                                className='form-control'
                                validate={{
                                required: {value: true, errorMessage: 'This Field is required'},
                                pattern: {value: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$', errorMessage: "Email format is invalid"}
                                }}
                                onChange={(e) => {
                                handleFieldChange(e)
                                }}
                                bsSize="lg"
                                placeholder={"developer@gmail.com"}
                            />
                            </div>
                        </Col>
                    </Row>

                    <ModalFooter className="px-0">
                        <button 
                            onClick={toggle}
                            type='button' 
                            className='btn btn-secondary' 
                            style={{width: "45%"}}>
                            Cancel
                        </button>
                        <button
                            disabled={loading}
                            style={{width: "45%"}}
                            type='submit' className='btn btn-success ms-auto'>
                            Submit
                        </button>
                    </ModalFooter>
                </AvForm>
            </ModalBody>
        </Modal>
    );
}

export default EditProfile;
